export default __webpack_public_path__ + "static/media/seattle.2fd71362.png";